import {
  Building,
  CalendarDays,
  ClipboardList,
  Folder,
  Grid3X3,
  Image,
  Inbox,
  Map,
  MapPin,
  Sparkles,
  Wrench,
  Zap,
} from '@lucide/vue'

import type { Component } from 'vue'

/**
 * Maps the icon names used by the backend navigation (app/Navigation/Sidebar.php)
 * to Lucide components.
 */
const iconByName: Record<string, Component> = {
  bolt: Zap,
  'building-office': Building,
  'calendar-days': CalendarDays,
  'clipboard-list': ClipboardList,
  folder: Folder,
  image: Image,
  inbox: Inbox,
  map: Map,
  'map-pin': MapPin,
  sparkles: Sparkles,
  'wrench-screwdriver': Wrench,
}

export function navigationIcon(name: string | undefined): Component {
  return (name === undefined ? undefined : iconByName[name]) ?? Grid3X3
}
